//@ts-ignore
import { getCurrentDeviceSize } from "@utils/DeviceDetection";
/**
 * Redirects to the given url and according to the breakpoint, we will open the new url on a new window or not.
 * @param props Contains the properties which manipulates the behaviour of the redirect
 * @param props.url The url to redirect
 * @param props.blankPage If set, we will open the url on a new tab according to the breakpoints sm, md, lg. Otherwise, the page will be opened in the same window
 * @param props.blankPage.sm If true, the url will be opened in a new window in sm breakpoint
 * @param props.blankPage.md If true, the url will be opened in a new window in md breakpoint
 * @param props.blankPage.lg If true, the url will be opened in a new window in lg breakpoint
 */
export var redirect = props => {
  var {
    url,
    blankPage
  } = props;
  //In case the object is null, then we will open the new page in the same window
  if (!blankPage) {
    window.location.href = url;
    return;
  }
  var deviceSize = getCurrentDeviceSize();
  if (blankPage.sm && deviceSize === "mobile" || blankPage.md && deviceSize === "tablet" || blankPage.lg && deviceSize === "desktop") window.open(url, "_blank");else window.location.href = url;
};